<template>
  <div>
    <div class="card" v-if="loading">
    <b-loading :is-full-page="true" :active="loading" :can-cancel="true"></b-loading>
  </div>
    <div class="card">
    <div class="modal-card">
      <header class="modal-card-head" >
                        <p class="modal-card-title">Guest Traveler</p>
                        <button
                            type="button"
                            class="delete"
                            @click="$emit('close')"/>
                    </header>
      <section class="modal-card-body" style="min-height: 12rem;">
        <div class="columns">
          <div class="column">
            <b-field label="First Name" label-position="on-border">
                <b-input  v-model="formData.firstName" ></b-input>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Middle Name" label-position="on-border">
                <b-input v-model="formData.middleName" ></b-input>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Last Name" label-position="on-border">
                <b-input v-model="formData.lastName" ></b-input>
            </b-field>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <b-field label="Gender" label-position="on-border">
              <b-select  v-model="formData.gender" placeholder="Select Gender" required expanded>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Non-Binary">Non-Binary</option>
              </b-select>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Date of Birth" label-position="on-border">
                <b-input v-model="formData.dob" placeholder="mm-dd-yyyy" v-cleave="masks.dob"></b-input>
            </b-field>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <b-field label="Email" label-position="on-border">
                <b-input value=""  v-model="formData.email" icon="email"></b-input>
            </b-field>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <b-field label="Cell Phone" label-position="on-border">
              <b-input type="tel" name="phone"  v-model="formData.cell" v-cleave="masks.phone" icon="phone"></b-input>
            </b-field>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <b-field label="Select a Policy" label-position="on-border">
              <b-select  v-model="formData.policyId" placeholder="Select A Policy" required expanded>
                  <option v-for="policy in policies" :value="policy.id" :key="policy.id" :disabled="policy.status != 'Active'">{{policy.ruleClass}} -- {{policy.status}}</option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div v-if="inputErrors" style="color: red; padding-top: 30px;">
              <li class="is-size-7" style="padding-left: 10px;" v-for="message in inputErrors" :key="`D ${message}`">
                {{ message}}
              </li>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot columns">
            <div class="column">

            </div>
            <div class="column is-2">
              <b-button
                  label="Save"
                  @click="checkInputs"
                  type="is-primary" />
            </div>
      </footer>
    </div>
  </div>
</div>
</template>

<script>
  import Cleave from 'cleave.js'
  require('cleave.js/dist/addons/cleave-phone.ca')
  var moment = require('moment'); // require
  // import CleavePhone from 'cleave.js/dist/addons/cleave-phone.i18n';
  const cleave = {
      name: 'cleave',
      bind(el, binding) {
          const input = el.querySelector('input')
          input._vCleave = new Cleave(input, binding.value)
      },
      unbind(el) {
          const input = el.querySelector('input')
          input._vCleave.destroy()
      }
  }

  export default {
    directives: { cleave },
    name: 'TravellerAddGuest',
    props: {
      },
    data: function () {
      return {
        isOpen: 0,
        dependentTravellers: [],
        loading: false,
        selectedTravellers: [],
        business: true,
        policies: [],
        formData: {
          firstName: '',
          lastName: '',
          middleName: '',
          gender: '',
          dob: '',
          email: '',
          cell: '',
          policyId: '',
        },
        masks: {
            creditCard: { creditCard: true },
            numeral: {
                numeral: true,
                numeralThousandsGroupStyle: 'thousand',
                prefix: '$ '
            },
            date: {
                date: true,
                datePattern: ['m', 'y']
            },
            dob: {
                date: true,
                delimiter: '-',
                datePattern: ['m', 'd', 'Y']
            },
            phone: {
              phone: true,
              phoneRegionCode: "US",
              delimiter: "-"
            }
        },
        inputErrors: false,
        newTravelerResult:[],
      }
    },
    computed: {
      result() {
        return this.$store.state.bookTravel.result;
      },
    },
    methods: {
      onInput(event) {
          this.rawValue = event.target._vCleave.getRawValue()
          this.value = event.target._vCleave.getFormattedValue()
      },
      checkInputs(){
        let messages = [];

        if(!this.formData.firstName){
          messages.push('Please add required First Name');
        }
        if(!this.formData.lastName){
          messages.push('Please add required Last Name');
        }
        if(!this.formData.gender){
          messages.push('Please select Gender');
        }
        if(!this.formData.email){
          messages.push('Please add your Email');
        }
        if(!this.formData.dob){
          messages.push('Please add your DOB');
        }
        if(!this.formData.cell){
          messages.push('Please add your Cell Phone Number');
        }
        if(!this.formData.policyId){
          messages.push('Please select Policy');
        }

        if (messages.length > 0){
          this.inputErrors = messages;
        }
        else{
          // console.log('proceed with traveler')
          this.save();
        }
      },
      save() {
        this.loading = true;

        var dob = this.formData.dob
        var newDate = moment(dob, 'MM-DD-YYYY').format('YYYY-MM-DD')
        var body = {
            "currentUser": {
                "contactId": this.$globals.profile.id
            },
            "traveler": {
                "isGuest": true,
                "firstName": this.formData.firstName,
                "lastName": this.formData.lastName,
                "middleName": this.formData.middleName,
                "email": this.formData.email,
                "mobilePhone": this.formData.cell,
                "gender": this.formData.gender,
                "dateOfBirth": newDate,
                "travelPolicyId": this.formData.policyId
            }
        }
        // console.log('body', body);

        this.$app.huddleLabsServerCall('profile/my-travelers/create', body)
          .then(result => {
            console.log('add guest traveller result', result);
            this.$emit('update', result.data);
            this.loading = false;
            this.$emit('close');
          });
      },
      confirm() {
              this.$buefy.dialog.confirm({
                  message: `You have travel in your itinerary that is linked to another traveller's policy. Changing travellers now will delete this trip. Do you wish to continue?`,
                  onConfirm: () => {this.$buefy.toast.open('Travellers changed'); this.confirmSave()}
              })
          },
      confirmSave() {
        this.$emit('close');
      },
      getPolicy() {
        var body = {"accountId": this.$globals.profile.account.id}
        this.$app.huddleLabsServerCall('profile/travel-policy/list', body)
          .then(result => {this.policies = result.data})
      },
    },
    mounted () {
      this.getPolicy();
    },
  }
</script>

<style scoped>
</style>
